import { useOrgUser } from '@/features/org/hooks/use-org-user';
import { OrgRole } from '@/features/org/validation/org-role.schema';

export const useCanManageOrgMembers = () => {
  const { data: orgUser } = useOrgUser();
  if (!orgUser) return false;

  return orgUser.role === OrgRole.OWNER || orgUser.role === OrgRole.ADMIN;
};
